import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { resolveSeo, NOT_FOUND_ROUTE, canonicalUrl, type SeoRoute } from "../../../src/seo/routes";

/**
 * Per-route <head> tags on client-side navigation, from the same manifest the
 * server injects on first load (src/seo/routes.ts). Pages must NOT set their
 * own <title> / description / canonical — a second source is how every page
 * ended up claiming to be the home page (audit 2026-10-01 C1).
 */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const seo = resolveSeo(pathname);
  if (seo.kind === "redirect") return null;
  const route: SeoRoute = seo.kind === "page" ? seo.route : NOT_FOUND_ROUTE;
  return (
    <Helmet>
      <title>{route.title}</title>
      <meta name="description" content={route.description} />
      <meta name="robots" content={route.noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:title" content={route.title} />
      <meta property="og:description" content={route.description} />
      <meta name="twitter:title" content={route.title} />
      <meta name="twitter:description" content={route.description} />
      {!route.noindex && <link rel="canonical" href={canonicalUrl(route.path)} />}
      {!route.noindex && <meta property="og:url" content={canonicalUrl(route.path)} />}
    </Helmet>
  );
}
